/**
 *  false:close,true:open
 */
export default {
  aaFastPass: true, //WMP-2702
  aaBundle: true, //WMP-2737
};
